<template lang="pug">
div(@click="select" :class="classes")
	span(v-if='hasPrice') {{ printCurrencyValue(cell.totalPrice) }}
	br
	span(v-if='hasPrice && availableAmount == 0') {{$t('sale.price_cell.worn_out', 'Esaurito')}}
</template>

<script setup>
import {get as _get} from 'lodash-es';
import { useBookingStore } from '@/stores/booking';
import { computed, inject } from 'vue';
import {printCurrencyValue} from '@/common-scripts/utilities'
import {useI18n} from "vue-i18n";

// const travelSolution = inject('solution');
const train = inject('train');
const booking = useBookingStore();
const { state: travelSolutionSelectionState, setSelectedTrainGridOffer } = inject('travelSolutionSelection');

const props = defineProps({
	columnId: String|Number,
	rowId: String|Number,
	travelSolution: Object
});
const {travelSolution} = props;
const i18n = useI18n();
const isSelected = computed(() => {
	return _get(travelSolutionSelectionState.selectedTrainGridOffers, [train.id, 'offerId']) == props.rowId && _get(travelSolutionSelectionState.selectedTrainGridOffers, [train.id, 'catalogServiceId']) == props.columnId;
});

const cell = computed(() => {
	return _get(travelSolution, 'priceGrid.'+train.id+'.matrix.'+props.rowId+'.'+props.columnId);
});

const hasPrice = computed(() => {
	return cell.value && typeof(cell.value.totalPrice) == "number"
});

const availableAmount = computed(() => {
	if(!cell.value || !cell.value.availableAmount) return 0;
	return Number(cell.value.availableAmount);
});

const isSelectable = computed(() => {
	return cell.value && typeof(cell.value.totalPrice) === 'number' && availableAmount.value > 0;
});

const classes = computed(() => {
	return {'active': isSelected.value, 'tw-cursor-pointer': isSelectable.value};
});

function select(){
	if(!isSelectable.value) return;
	setSelectedTrainGridOffer(train.id, props.rowId, props.columnId);
}
</script>